import { ObjectId } from 'mongodb';
import { LocationRef } from './db-location';
import { Metadata } from './db';

export enum CombinationColor {
  Black = 'black',
  Blue = 'blue',
  Green = 'green',
  Grey = 'grey',
  Orange = 'orange',
  Red = 'red',
  Yellow = 'yellow',
  White = 'white',
  Multicolor = 'multicolor',
  Striped = 'striped',
  Unknown = 'unknown',
}

export enum ItemType {
  Clothing = 'clothing',
  Equipment = 'equipment',
}

export enum ItemOrigin {
  CheckaOld = 'checka_old',
  Checka = 'checka',
  IkeaEquipment = 'ikea_equipment',
}

export interface ItemCombinations {
  fit?: string;
  size?: string;
  color?: CombinationColor;
}

export class ItemProperties {
  material?: string;
  height?: number;
  width?: number;
  depth?: number;
  weight?: number;
}

export interface Price {
  amount: number;
  currency: string;
}

export interface ItemRef {
  _id: ObjectId;
  productName: string;
  displayName: string;
  type: ItemType;
}

export type ItemRefWithImage = ItemRef & {
  imageUrl?: string;
};

export type Item = ItemRef & {
  slug: string;
  categories: string[];
  category: number;
  location?: LocationRef;
  imageUrls: string[];
  sku: string;
  price?: Price;
  description: string;
  combinations: ItemCombinations;
  properties: ItemProperties;
  documents: {
    name: string;
    url: string;
  }[];
  source: {
    /*
     * CHECKA: old checka app
     * IKEA_EQUIPMENT: equipment.ikea.com
     * ...
     */
    origin: ItemOrigin;
    url?: string;
  };
} & Metadata;

/**
 * Category of items
 */

export type ItemCategory = {
  _id: number;
  name: string;
  type: ItemType;
  subcategories?: Omit<ItemCategory, 'type'>[];
};

export const CATEGORIES: ItemCategory[] = [
  {
    _id: 0,
    name: 'Personal Safety and Protection',
    type: ItemType.Clothing,
    subcategories: [
      { _id: 1, name: 'Safety Apparel' },
      { _id: 2, name: 'Safety Footware' },
      { _id: 3, name: 'Face & Head Protection' },
      { _id: 4, name: 'Vision protection & accessories' },
      { _id: 5, name: 'Hearing Protectors' },
    ],
  },
  {
    _id: 100,
    name: 'Clothing',
    type: ItemType.Clothing,
    subcategories: [
      { _id: 101, name: 'Dresses, skirts, saris and kimonos' },
      { _id: 102, name: 'Clothing accessories' },
      { _id: 103, name: 'Jackets' },
      { _id: 104, name: 'T-shirts' },
      { _id: 105, name: 'Slacks, trousers and shorts' },
      { _id: 106, name: 'Shirts and blouses' },
      { _id: 107, name: 'Shoes' },
    ],
  },
  {
    _id: 200,
    type: ItemType.Equipment,
    name: 'Computer Equipment and Accessories',
    subcategories: [
      { _id: 201, name: 'Docking stations' },
      { _id: 202, name: 'Bar code reader equipment' },
      { _id: 203, name: 'Keyboards' },
      { _id: 204, name: 'Computer mouse' },
      { _id: 205, name: 'Mouse pads' },
      { _id: 206, name: 'Mouse wrist rest' },
    ],
  },
  { _id: 300, type: ItemType.Equipment, name: 'Signage and accessories' },
  { _id: 400, type: ItemType.Equipment, name: 'Furniture and Furnishings' },
  { _id: 500, type: ItemType.Equipment, name: 'Tools' },
];
